const quickLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Industries', href: '#industries' },
  { label: 'Results', href: '#results' },
  { label: 'Work', href: '#work' },
  { label: 'Contact', href: '#contact' },
];

const services = [
  'Facebook & Instagram Ads',
  'AI Audience Targeting',
  'Full-Funnel Marketing',
  'Conversion Rate Optimization',
  'Lead Nurturing Systems',
  'Creative Strategy',
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#040404] border-t border-white/6">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand column */}
          <div className="md:col-span-2">
            <img
              src="https://storage.readdy-site.link/project_files/6a9ee8b5-3e14-4cac-83f4-7fb00d701629/1e96ec08-cdc0-4a03-9997-74d69b8440f9_cgoeight-trasnparent.png?v=7f1d19bcf2e06a33cfa1bc775f6a704b"
              alt="CGoeight Media"
              className="h-14 w-auto object-contain mb-5"
            />
            <p className="text-white/35 text-sm leading-relaxed max-w-xs mb-6">
              The performance marketing agency built for businesses that refuse to plateau.
              AI-powered. Results-obsessed. Phoenix-based. Global reach.
            </p>
            <div className="flex items-center gap-1 text-white/20 text-xs mb-6">
              <i className="ri-map-pin-line text-electric-blue/50" />
              <span>Phoenix, Arizona, USA</span>
            </div>
            {/* Social icons */}
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-instagram-line', label: 'Instagram' },
                { icon: 'ri-facebook-box-line', label: 'Facebook' },
                { icon: 'ri-linkedin-box-line', label: 'LinkedIn' },
                { icon: 'ri-twitter-x-line', label: 'X' },
              ].map(({ icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="w-9 h-9 flex items-center justify-center rounded-md border border-white/8 text-white/30 hover:text-white hover:border-white/20 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide mb-5 uppercase">Navigation</h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-white/35 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide mb-5 uppercase">Services</h4>
            <ul className="flex flex-col gap-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-white/35 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/18 text-xs">
            &copy; {new Date().getFullYear()} CGoeight Media. All rights reserved. Phoenix, AZ.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/18 text-xs hover:text-white/40 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-white/18 text-xs hover:text-white/40 transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
